import "./constants";
import { LAYOUT } from "./constants";

export function setupWindow() {
  // From https://www.bram.us/2020/05/06/100vh-in-safari-on-ios/
  const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  window.addEventListener("load", setVh);
  window.addEventListener("resize", setVh);
}

export function isSmallViewport() {
  return window.innerWidth < LAYOUT.BREAKPOINTS.TABLET;
}
